import React from "react";
import { useTranslation } from "react-i18next";

export const Features = (props) => {
  const { t } = useTranslation();

  const benefits = [
    { icon: "fa fa-star", key: "forLivingOrInvestment" },
    { icon: "fa fa-building", key: "moreOptions" },
    { icon: "fa fa-clock-o", key: "time" },
    { icon: "fa fa-rocket", key: "beFirst" },
    { icon: "fa fa-bell-o", key: "notifications" },
    { icon: "fa fa-unlock", key: "free" }
  ];

  return (
    <div id="benefits" className="text-center">
      <div className="container">
        <div className="col-md-10 col-md-offset-1 section-title">
          <h2>{t('benefits.title')}</h2>
        </div>
        <div className="row">
          {benefits.map((benefit, i) => (
            <React.Fragment key={`${benefit.key}-${i}`}>
              <div className="col-xs-6 col-md-4">
                {" "}
                <i className={benefit.icon}></i>
                <h3>{t(`benefits.${benefit.key}.title`)}</h3>
                <p>{t(`benefits.${benefit.key}.text`)}</p>
              </div>
              {((i + 1) % 3 === 0) && (
                <div className="clearfix visible-md-block visible-lg-block"></div>
              )}
              {((i + 1) % 2 === 0) && (
                <div className="clearfix visible-xs-block"></div>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
};
